export default __webpack_public_path__ + "static/media/first_new.69035240.png";